var _g, _path, _rect, _g2, _path2, _rect2, _g3, _path3, _rect3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage4Bar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 33,
    viewBox: "0 0 369 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_2423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15,
    fill: "#004068",
    stroke: "#004068",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0778 20.142L22.7198 10.5L24 11.7802L13.0778 22.7025L7.99951 17.6257L9.27976 16.3455L13.0778 20.142Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 15.5,
    width: 80,
    height: 2,
    fill: "#004068"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_2423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 16.5,
    r: 15,
    fill: "#004068",
    stroke: "#004068",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.078 20.142L134.72 10.5L136 11.7802L125.078 22.7025L120 17.6257L121.28 16.3455L125.078 20.142Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 15.5,
    width: 80,
    height: 2,
    fill: "#004068"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9_2423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 16.5,
    r: 15,
    fill: "#004068",
    stroke: "#004068",
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.078 20.142L246.72 10.5L248 11.7802L237.078 22.7025L232 17.6257L233.28 16.3455L237.078 20.142Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 15.5,
    width: 80,
    height: 2,
    fill: "#004068"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_9_2423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 352.5,
    cy: 16.5,
    r: 15,
    fill: "white",
    stroke: "#004068",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.5,
    cy: 16.5,
    r: 5.5,
    fill: "#EA7024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_2423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_2423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(112.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9_2423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(224.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_9_2423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(336.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage4Bar);
export default __webpack_public_path__ + "static/media/page4bar.113aaa694fe5ef900b6c5f5b3b2f37fa.svg";
export { ForwardRef as ReactComponent };